import React from "react";
import { motion } from "framer-motion";
import { fadeVariants } from "../../../../components/shared/utils/animations";

export default (props) => {
  const roomData = props.roomData;
  const gameObj = props.gameObj;
  const game_code = roomData?.game_code;
  let preguess_header = "";
  let guessingTeam = "A";
  if (
    roomData &&
    roomData.game_state &&
    roomData.game_state &&
    roomData.game_state.current_team
  ) {
    guessingTeam = roomData.game_state.current_team;
  }
  let preguess_description =
    "Their turn will start once \n\n their Quarterback starts the round.";
  if (gameObj) {
    if (gameObj && gameObj.screens && gameObj.screens.vb) {
      preguess_description = gameObj.screens.vb.preguess_description;
      preguess_header = gameObj.screens.vb.team_a.preguess_header;
      if (guessingTeam !== "A") {
        preguess_header = gameObj.screens.vb.team_b.preguess_header;
      }
    }
  }
  const description = preguess_description.split("\n\n");

  return (
    <motion.div
      variants={fadeVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="guessing-wrapper text-center"
    >
      <h2 className="text-orange ">
        {guessingTeam === "A" ? (
          <span>{preguess_header}</span>
        ) : (
          <h1>{preguess_header}</h1>
        )}
        {description &&
          description.map((item, index) => {
            return (
              <p key={index} className="text">
                {item}
              </p>
            );
          })}
      </h2>
    </motion.div>
  );
};
